export const pointsInVisibleArea = (availableMapArea, pointCoord) => {
    return (
        availableMapArea[0][0] < pointCoord[0] &&
        availableMapArea[0][1] < pointCoord[1] &&
        availableMapArea[1][0] > pointCoord[0] &&
        availableMapArea[1][1] > pointCoord[1]
    );
};
